// test954
(954 && 0);
